import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: frankgrinaert
 * id B60DF8C7-F693-4E2B-B5AB-65CA6DC21A8E
 * name play-box
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/play-box.svg
 * tags
 */
export const PlayBoxIcon = createSvgIcon(<><path d="M19 3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.89 20.1 3 19 3M10 16V8L15 12" /></>, 'PlayBoxIcon');
export default PlayBoxIcon